import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import { Form, Hyperlink } from '@openedx/paragon';
import PropTypes from 'prop-types';

import messages from '../../messages';

const TermsOfService = (props) => {
  const { formatMessage } = useIntl();
  const {
    errorMessage, onChangeHandler, value,
  } = props;

  return (
    <div id="terms-of-service" className="micro">
      <Form.Checkbox
        className="form-field--checkbox mt-1"
        controlClassName="rounded border"
        id="tos"
        checked={value}
        name="terms_of_service"
        value={value}
        onChange={onChangeHandler}
      >
        <span>
        <FormattedMessage
          id="register.page.terms.of.service"
          defaultMessage="I have read and accept the {privacyPolicy}, {generalTermsOfUse} and {cookiePolicy}."
          description="Text that appears on registration form stating privacy policy, terms of use and cookie policy.
                       They are legal documents that users must agree to."
          values={{
            privacyPolicy: (
              <Hyperlink variant="muted" destination={getConfig().PRIVACY_POLICY || '#'} target="_blank" showLaunchIcon={false}>
                {formatMessage(messages['privacy.policy'])}
              </Hyperlink>
            ),
            generalTermsOfUse: (
              <Hyperlink variant="muted" destination={getConfig().TOS_LINK || '#'} target="_blank" showLaunchIcon={false}>
                {formatMessage(messages['general.terms.of.use'])}
              </Hyperlink>
            ),
            cookiePolicy: (
              <Hyperlink variant="muted" destination={getConfig().COOKIE_POLICY || '#'} target="_blank" showLaunchIcon={false}>
                {formatMessage(messages['cookie.policy'])}
              </Hyperlink>
            ),
          }}
        />
        </span>
      </Form.Checkbox>
      {errorMessage && (
        <Form.Control.Feedback type="invalid" className="form-text-size" hasIcon={false}>
          {errorMessage}
        </Form.Control.Feedback>
      )}
    </div>
  );
};

TermsOfService.defaultProps = {
  errorMessage: '',
  value: false,
};

TermsOfService.propTypes = {
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  value: PropTypes.bool,
};

export default TermsOfService;
